import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { resolveDependencies } from '../helpers/dependencies.js';
import ConditionController from '../ConditionController/ConditionController.js';
import DragControllerRow from '../DragControllerRow/DragControllerRow.js';
import 'lodash';
import '@elliemae/ds-utilities/operators';
import '../helpers/types.js';
import '@elliemae/ds-basic/Tooltip';
import '@elliemae/ds-basic/Popper';
import '@elliemae/ds-basic/Icon';
import '@elliemae/ds-basic/Button';
import '@elliemae/ds-icons/MoreOptionsVert';
import '@elliemae/ds-icons/QueryRemove';
import '@elliemae/ds-icons/QueryAdd';
import '@elliemae/ds-icons/ParenthesisAdd';
import '../ToolBarAnimation/ToolBarAnimation.js';
import '@babel/runtime/helpers/esm/extends';
import '@elliemae/ds-shared/Animations/GrowRight';
import '../helpers/constants.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@elliemae/ds-icons/GripperVertical';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RenderField = function RenderField(_ref) {
  var target = _ref.target,
      component = _ref.component,
      valueProp = _ref.valueProp,
      additionalInfo = _ref.additionalInfo,
      handleMouseEnterInput = _ref.handleMouseEnterInput,
      handleMouseLeaveInput = _ref.handleMouseLeaveInput,
      onChangeHandler = _ref.onChangeHandler;
  var ref = React.useRef();
  var id = React.useMemo(function () {
    return "el_".concat(String.fromCharCode(65 + Math.floor(Math.random() * 26)));
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "em-ds-query-builder-row-input child-type-".concat(target),
    onMouseDownCapture: function onMouseDownCapture() {
      // eslint-disable-next-line no-underscore-dangle
      var _refInput = ref.current.querySelector("#".concat(id));

      if (_refInput && _refInput.focus) setTimeout(_refInput.focus());
      handleMouseEnterInput();
    },
    onMouseEnter: function onMouseEnter() {
      return handleMouseEnterInput();
    },
    onMouseLeave: function onMouseLeave() {
      return handleMouseLeaveInput();
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: "em-ds-query-builder-row__input-controller"
  }, /*#__PURE__*/React.cloneElement(component, {
    id: id,
    onChange: function onChange(e, extraData) {
      return onChangeHandler(e, target, extraData);
    },
    value: valueProp != null ? valueProp : '',
    checked: valueProp === true,
    additionalInfo: additionalInfo ? additionalInfo[target] : {}
  }))); // return React.useMemo(
  //   () => (
  //     <div
  //       className={`em-ds-query-builder-row-input child-type-${target}`}
  //       onMouseDownCapture={() => {
  //         // eslint-disable-next-line no-underscore-dangle
  //         const _refInput = ref.current.querySelector(`#${id}`);
  //         if (_refInput && _refInput.focus) setTimeout(_refInput.focus());
  //         handleMouseEnterInput();
  //       }}
  //       onMouseEnter={() => handleMouseEnterInput()}
  //       onMouseLeave={() => handleMouseLeaveInput()}
  //     >
  //       <div ref={ref} className="em-ds-query-builder-row__input-controller">
  //         {React.cloneElement(component, {
  //           id,
  //           onChange: (e, extraData) => onChangeHandler(e, target, extraData),
  //           value: valueProp != null ? valueProp : '',
  //           checked: valueProp === true,
  //           additionalInfo: additionalInfo ? additionalInfo[target] : {},
  //         })}
  //       </div>
  //     </div>
  //   ),
  //   [target, component, valueProp, additionalInfo],
  // );
};

var QueryBuilderRow = /*#__PURE__*/function (_Component) {
  _inherits(QueryBuilderRow, _Component);

  var _super = _createSuper(QueryBuilderRow);

  function QueryBuilderRow(props) {
    var _this;

    _classCallCheck(this, QueryBuilderRow);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnterRow", function () {});

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeaveRow", function () {
      _this.handleTooltipRow(false);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnterInput", function () {
      var setDraggableItems = _this.props.setDraggableItems;
      setDraggableItems(false);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeaveInput", function () {
      var setDraggableItems = _this.props.setDraggableItems;
      setDraggableItems(true);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTooltipRow", function (isOpen) {
      _this.setState({
        isOpen: isOpen
      });
    });

    _this.state = {
      isOpen: false
    };
    _this.onChangeHandler = _this.onChangeHandler.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(QueryBuilderRow, [{
    key: "onChangeHandler",
    value: function onChangeHandler(e, target, extraData) {
      var _handleFieldChange;

      var _this$props = this.props,
          handleFieldChange = _this$props.handleFieldChange,
          idFilter = _this$props.idFilter,
          idGroup = _this$props.idGroup,
          additionalInfo = _this$props.additionalInfo;
      var eventValue = e;

      if (e && e.target) {
        var _e$target = e.target,
            value = _e$target.value,
            checked = _e$target.checked;
        if (value || value === '' || typeof value === 'boolean') eventValue = value;else eventValue = checked || e;
      }

      handleFieldChange((_handleFieldChange = {}, _defineProperty(_handleFieldChange, target, eventValue), _defineProperty(_handleFieldChange, "idFilter", idFilter), _defineProperty(_handleFieldChange, "idGroup", idGroup), _defineProperty(_handleFieldChange, "additionalInfo", _objectSpread(_objectSpread({}, additionalInfo), {}, _defineProperty({}, target, extraData))), _defineProperty(_handleFieldChange, "target", target), _handleFieldChange));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isOpen = this.state.isOpen;
      var _this$props2 = this.props,
          fields = _this$props2.fields,
          onAddFilter = _this$props2.onAddFilter,
          onRemoveFilter = _this$props2.onRemoveFilter,
          onAddRuleContainer = _this$props2.onAddRuleContainer,
          field = _this$props2.field,
          operator = _this$props2.operator,
          value = _this$props2.value,
          additionalInfo = _this$props2.additionalInfo,
          items = _this$props2.items,
          singleRow = _this$props2.singleRow,
          toolTipZIndex = _this$props2.toolTipZIndex;

      var _convertPropToCssClas = convertPropToCssClassName('query-builder-row', isOpen ? 'has-open-tooltip' : 'has-close-tooltip', singleRow ? 'is-single-row' : 'is-multiple-row'),
          cssClassName = _convertPropToCssClas.cssClassName,
          classNameBlock = _convertPropToCssClas.classNameBlock,
          classNameElement = _convertPropToCssClas.classNameElement;

      var test = resolveDependencies({
        field: field,
        operator: operator,
        value: value,
        additionalInfo: additionalInfo
      }, fields);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: cssClassName,
        onMouseEnter: this.handleMouseEnterRow,
        onMouseLeave: this.handleMouseLeaveRow
      }, !singleRow && /*#__PURE__*/React.createElement(DragControllerRow, {
        className: classNameElement('drag-controller'),
        onMouseDownCapture: function onMouseDownCapture() {
          return _this2.handleMouseLeaveInput();
        }
      }), test.map(function (renderField) {
        var target = renderField.target,
            component = renderField.component;
        var valueProp = _this2.props[target];
        return /*#__PURE__*/React.createElement(RenderField, {
          component: component,
          target: target,
          valueProp: valueProp,
          onChangeHandler: _this2.onChangeHandler,
          handleMouseEnterInput: _this2.handleMouseEnterInput,
          handleMouseLeaveInput: _this2.handleMouseLeaveInput
        });
      }), !singleRow && /*#__PURE__*/React.createElement("div", {
        className: classNameBlock('controller')
      }, /*#__PURE__*/React.createElement(ConditionController, {
        handleTooltipRow: this.handleTooltipRow,
        isOpen: isOpen,
        items: items,
        onAddFilter: onAddFilter,
        onAddRuleContainer: onAddRuleContainer,
        onRemoveFilter: onRemoveFilter,
        toolTipZIndex: toolTipZIndex
      }))));
    }
  }]);

  return QueryBuilderRow;
}(Component);

export default QueryBuilderRow;
//# sourceMappingURL=QueryBuilderRow.js.map
